__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "lebron-front";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@maas-components/styles", "4.17.0", () => (Promise.all([__webpack_require__.e(8296), __webpack_require__.e(6746), __webpack_require__.e(9896), __webpack_require__.e(2950), __webpack_require__.e(2562), __webpack_require__.e(1734), __webpack_require__.e(1368)]).then(() => (() => (__webpack_require__(29896))))));
			register("@maas-tools/accounts", "3.2.0", () => (Promise.all([__webpack_require__.e(2950), __webpack_require__.e(735)]).then(() => (() => (__webpack_require__(30735))))));
			register("@maas-tools/keycloak", "2.1.0", () => (Promise.all([__webpack_require__.e(6018), __webpack_require__.e(2950), __webpack_require__.e(2559)]).then(() => (() => (__webpack_require__(96018))))));
			register("@material-ui/core", "4.12.4", () => (Promise.all([__webpack_require__.e(8296), __webpack_require__.e(6746), __webpack_require__.e(7951), __webpack_require__.e(6273), __webpack_require__.e(6838), __webpack_require__.e(2950), __webpack_require__.e(2562), __webpack_require__.e(1734), __webpack_require__.e(6982), __webpack_require__.e(6225)]).then(() => (() => (__webpack_require__(46838))))));
			register("@material-ui/icons", "4.11.3", () => (Promise.all([__webpack_require__.e(8296), __webpack_require__.e(9423), __webpack_require__.e(2950), __webpack_require__.e(2562), __webpack_require__.e(4078)]).then(() => (() => (__webpack_require__(29423))))));
			register("@material-ui/styles", "4.11.5", () => (Promise.all([__webpack_require__.e(5035), __webpack_require__.e(2950), __webpack_require__.e(4548)]).then(() => (() => (__webpack_require__(45035))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(6599), __webpack_require__.e(2950), __webpack_require__.e(1982)]).then(() => (() => (__webpack_require__(86599))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(1362), __webpack_require__.e(2950), __webpack_require__.e(1074)]).then(() => (() => (__webpack_require__(41362))))));
			register("react", "17.0.2", () => (__webpack_require__.e(390).then(() => (() => (__webpack_require__(50390))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};